import { NgModule } from '@angular/core';
import { ValueTransformDirective } from './value-transform.directive';

@NgModule({
  exports: [ValueTransformDirective],
  imports: [ValueTransformDirective],
})
export class FmntsMaskedInputModule {}
